export const FETCH_GROUPING_USER_REQUEST = 'FETCH_GROUPING_USER_REQUEST';
export const FETCH_GROUPING_USER_SUCCESS = 'FETCH_GROUPING_USER_SUCCESS';
export const FETCH_GROUPING_USER_FAILURE = 'FETCH_GROUPING_USER_FAILURE';
